import { withChartLayout } from 'components/common';
import SavedDischargePlanning from 'components/features/chart/discharge-planning/saved-discharge-planning/SavedDischargePlanning';

const SavedDischargePlanningPage = withChartLayout('Saved Discharge Planning')(SavedDischargePlanning);
export default SavedDischargePlanningPage;
